<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <app-base-main parentTable>
        <template #filter-group>
            <app-filter-group
                    @query="$gjNoticeQuery"
                    @reset="$gjReset">

                <gj-market-select
                        v-model="filter.marketIds"
                        multiple
                        width="170px"
                        placeholder="请选择店铺"
                ></gj-market-select>

                <gj-date-picker
                        type="daterange"
                        v-model="filter.date"/>
                <gj-select-input
                        v-model="filter.keyword"
                        :options="[
                       {id: 'msku', text: 'MSKU'},
                       {id: 'asin', text: 'ASIN'},
                       {id: 'fnsku', text: 'FNSKU'},
                       {id: 'amazonOrderId', text: '订单号'},
                       {id: 'reimbursementId', text: '赔偿编号'}
                   ]"
                >
                </gj-select-input>

                <template #right>
                    <gj-tool-group
                            setting :table-name="tableName"
                            :table-columns="columns"
                            :download="$permission('reimbursement:export')"
                            download-url="/operation/reimbursement/export"
                            :download-params="globalParams"
                            :sort-gjtable="$refs.gjTable"
                            help
                    >
                    </gj-tool-group>
                    <view-setting
                            :ref="REF_VIEW_SETTING"
                            save-mode="remote"
                            :use-default="true"
                            :module-name="moduleName"
                            :config="model"
                            :fn-generate-params="generateViewParams"
                            @view-change="handleChangeView"
                            @view-complete="handCompleteView"
                    >
                    </view-setting>
                </template>
            </app-filter-group>
        </template>
        <template #table>
            <gj-table
                    ref="gjTable"
                    adaptParent
                    :name="tableName"
                    :data="tableData"
                    :columns="columns"
                    :loading="loading"
                    sortable="custom"
                    :default-sort="{prop: 'approvalDate', order: 'descending'}"
                    :size="'has-picture'"
                    :pagination="pagination"
                    @sort-change="$gjSortChange"
                    @page-change="$gjNoticeQuery">
                <template v-slot:asin="{row}">
                    <el-row>
                            <gj-link :href="row.asinUrl" target="_blank">{{row.asin | defaultShow}}</gj-link>
                            <gj-copy-icon v-if="isMeaningful(row.asin)" :content="row.asin"/>
                    </el-row>
                </template>
            </gj-table>
        </template>
    </app-base-main>

</template>

<script>
    import {isMeaningfulMixin, queryMixin} from "../../../../minxins";
    import {exportReimbursement, getReimbursementPage} from "../../../../api/statistics";
    import {isMeaningful} from "../../../../utils/common";
    import {convertToDate, generateViewParams} from "../../../../utils/date.util";
    import viewConfig from './viewConfig'
    export default {
        name: "app-reimbursement",
        mixins: [queryMixin, isMeaningfulMixin],
        components: {},
        data() {
            return {
                tableName: 'reimbursement',
                columns: [
                    // id: 字段ID，用于优化渲染以及自定义列，必填
                    // header: 表头名称结构为：slot:slotName:name（slot: 是否插槽，slotName: 引用的插槽名，name：表头名称，用于自定义列的表头名）
                    // field: 字段内容域，类型为数据字段名或slot
                    // help: 帮助信息（问号）
                    // notCustomColumn: 是否是自定义字段，默认：false
                    // default: 是否自定义列默认字段
                    {id: 'marketName', header: '店铺/国家', field: 'marketName', minWidth: '120px', fixed: 'left', default: true},
                    {id: 'approvalDate', header: '时间', field: 'approvalDate', sortable: true, minWidth: '170px', fixed: 'left', default: true},
                    {id: 'reimbursementId', header: '赔偿编号', field: 'reimbursementId', minWidth: '100px', fixed: 'left', default: true},
                    {id: 'caseId', header: 'CaseId', field: 'caseId', minWidth: '120px', default: true},
                    {id: 'amazonOrderId', header: '订单号', field: 'amazonOrderId', minWidth: '170px', default: true},
                    {id: 'reason', header: '原因', field: 'reason', minWidth: '110px', default: true},
                    {id: 'productName', header: '商品标题', field: 'productName', minWidth: '150px', default: true,overflowLine: 1},
                    {id: 'asin', header: 'ASIN', field: 'slot:asin', minWidth: '140px', default: true, sortable: true},
                    {id: 'msku', header: 'MSKU', field: 'msku', minWidth: '140px', default: true, sortable: true, copyable:true},
                    {id: 'fnsku', header: 'FNSKU', field: 'fnsku', minWidth: '110px', default: true,sortable: true},
                    {id: 'condition', header: '状况', field: 'condition', minWidth: '100px', default: true},
                    {id: 'currencyUnit', header: '币种', field: 'currencyUnit', minWidth: '90px', default: true},
                    {id: 'amountPerUnit', header: '每件商品赔偿金额', field: 'amountPerUnit', minWidth: '140px', align: 'right', sortable: true, default: true},
                    {id: 'amountTotal', header: '总金额', field: 'amountTotal', minWidth: '100px', align: 'right', sortable: true, default: true},
                    {id: 'quantityReimbursedCash', header: '赔偿数量(现金)', field: 'quantityReimbursedCash', minWidth: '130px', align: 'right', sortable: true, default: true},
                    {id: 'quantityReimbursedInventory', header: '赔偿数量(库存)', field: 'quantityReimbursedInventory', minWidth: '130px', align: 'right', sortable: true, default: true},
                    {id: 'quantityReimbursedTotal', header: '赔偿数量(总计)', field: 'quantityReimbursedTotal', minWidth: '130px', align: 'right', sortable: true, default: true},
                    {id: 'originalReimbursementId', header: '原始赔偿编号', field: 'originalReimbursementId', minWidth: '120px', default: true},
                    {id: 'originalReimbursementType', header: '赔偿类型', field: 'originalReimbursementType', minWidth: '140px',default: true}
                ],
                tableData: [],
                filter: {
                    marketIds: [],
                    date: null,
                    keyword: {
                        key: 'msku', value: null
                    },
                },
                modalVisible: {
                    logModal: false,
                    detailModal: false,
                    clickDownload: false,
                },
                model: viewConfig,
                moduleName: 'COMPENSATE',
                cacheOptions: {
                    useCache: true,
                }
            }
        },
        created() {
            this.sort.prop = 'approvalDate';
        },
        methods: {
            generateViewParams,
            /**
             * 设置全局查询参数
             */
            mergeRemoteParams (params) {
                const date = params.date ? params.date : (params.startDateTime && params.endDateTime ? [params.startDateTime, params.endDateTime] : this.filter.date)
                this.filter = Object.assign({}, this.filter, {
                    ...params,
                    date
                })
            },
            $gjQueryInitParams() {
                return {
                    filter: {
                        marketIds: [],
                        month: null,
                        keyword: {
                            key: 'msku', value: null
                        }
                    }
                };
            },
            /**
             *
             * @param params 查询条件参数
             * @override queryMixin
             * @returns {{ marketIds: *}}
             */
            $gjCacheCallback(params) {
                return {
                    marketIds: params.marketIds
                };
            },
            $gjQuery() {
                // 构造查询参数
                const params = {
                    model: {
                        marketIds: this.filter.marketIds,
                        startMarketTime: isMeaningful(this.filter.date) ? convertToDate(this.filter.date[0]) : null,
                        endMarketTime: isMeaningful(this.filter.date) ? convertToDate(this.filter.date[1]) : null
                    },
                    ...this.queryPagination,
                    ...this.querySort
                };
                params.model[this.filter.keyword.key] = this.filter.keyword.value;
                this.globalParams = params;
                // 查询
                this.loading = true;
                getReimbursementPage(params)
                    .then((data) => {
                        if (isMeaningful(data)) {
                            this.tableData = data.records;

                            this.pagination = this.getPagination(data);
                        }
                    })
                    .complete(() => {
                        this.loading = false;
                    })
            },
            download() {
                exportReimbursement(this.globalParams);
            }
        },
    }
</script>

<style scoped>

</style>
